import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import DoneIcon from '@mui/icons-material/Done'
import { useTheme } from '@mui/material/styles'
import { black, blue, green, grey } from '../../../../colors'

export interface SurveyTypeBoxProps {
  selected: boolean
  onClick: () => void
  icon: React.ReactNode
  title: string
  description: string
  chipLabel?: string
}

export const SurveyTypeBox: React.FC<SurveyTypeBoxProps> = ({
  selected,
  onClick,
  icon,
  title,
  description,
  chipLabel
}) => {
  const theme = useTheme()
  return (
    <Box
      onClick={onClick}
      sx={{
        border: `2px solid ${selected ? blue[1100] : grey[550]}`,
        backgroundColor: grey[750],
        borderRadius: theme.spacing(4),
        p: 3,
        cursor: 'pointer',
        width: 552,
        position: 'relative',
        minHeight: 200,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'border-color 0.2s'

      }}
      tabIndex={0}
      role="button"
      aria-pressed={selected}
    >
      {selected && (
        <DoneIcon sx={{ color: green[700], position: 'absolute', top: 16, left: 16, fontSize: 28 }} />
      )}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={theme.spacing(1)}
        mt={theme.spacing(2)}
      >
        {icon}
      </Box>
      <Typography align="center" fontWeight={600} fontSize={18} color={black[100]} mt={1}>
        {title}
      </Typography>
      {chipLabel && (
        <Box display="flex" justifyContent="center" mt={theme.spacing(2)} mb={theme.spacing(4)}>
          <Chip
            variant="outlined"
            color="success"
            label={chipLabel}
            sx={{
              borderRadius: theme.spacing(1.5),
              border: `1px solid ${green[50]}`,
              fontWeight: 500,
              color: green[100],
              padding: theme.spacing(2),
              backgroundColor: green[0]
            }}
          />
        </Box>
      )}
      <Typography align="center" color={black[100]} fontSize={16}>
        {description}
      </Typography>
    </Box>
  )
}
